import { LotStatus } from '@parallel-fluidics/shared/constants';
import { travelerLastStepPassed } from '@parallel-fluidics/shared/models/travelers';

/**
 * Bucket a trace walk into the quarantine action's plan: which lots
 * will change status (everything not already Quarantined, Empty
 * included — an empty bag's output is still suspect) and what happens
 * to each affected traveler — completed ones get rejected, in-progress
 * ones get flagged, shipped ones get the same flag note plus surfaced
 * for customer follow-up. Pure, so the confirm modal previews exactly
 * what the api will execute.
 *
 * @param {{lotsById: object, travelersById: object}} trace
 * @returns {{
 *   lots: Array<object>,
 *   rejected: Array<{traveler: object, affectedCodes: string[]}>,
 *   flagged: Array<{traveler: object, affectedCodes: string[]}>,
 *   shipped: Array<{traveler: object, affectedCodes: string[]}>,
 * }}
 */
export default function planLotQuarantine(trace) {
  const lots = Object.values(trace.lotsById)
    .filter((lot) => lot.status !== LotStatus.QUARANTINED);

  const rejected = [];
  const flagged = [];
  const shipped = [];
  Object.values(trace.travelersById).forEach((traveler) => {
    const affectedCodes = (traveler.componentLotIds || [])
      .filter((componentLotId) => trace.lotsById[componentLotId])
      .map((componentLotId) => trace.lotsById[componentLotId].code || componentLotId);
    const entry = { traveler, affectedCodes };
    if (traveler.shipped) shipped.push(entry);
    else if (travelerLastStepPassed(traveler.steps)) rejected.push(entry);
    else flagged.push(entry);
  });

  return {
    lots, rejected, flagged, shipped,
  };
}
